/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClippInfo,
} from '../models/index';
import {
    ClippInfoFromJSON,
    ClippInfoToJSON,
} from '../models/index';

export interface GetProspectClippInfoRequest {
    prospectUid: string;
}

/**
 * 
 */
export class ClippServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProspectClippInfo without sending the request
     */
    async getProspectClippInfoRequestOpts(requestParameters: GetProspectClippInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['prospectUid'] == null) {
            throw new runtime.RequiredError(
                'prospectUid',
                'Required parameter "prospectUid" was null or undefined when calling getProspectClippInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/clipp/information/{prospectUid}`;
        urlPath = urlPath.replace(`{${"prospectUid"}}`, encodeURIComponent(String(requestParameters['prospectUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Information for Clipp integration
     */
    async getProspectClippInfoRaw(requestParameters: GetProspectClippInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClippInfo>> {
        const requestOptions = await this.getProspectClippInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClippInfoFromJSON(jsonValue));
    }

    /**
     * Get Information for Clipp integration
     */
    async getProspectClippInfo(requestParameters: GetProspectClippInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClippInfo> {
        const response = await this.getProspectClippInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
